import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DictionaryParameterEntity } from "../types/dictionary-parameter-entity";

@Injectable({
  providedIn: 'root'
})
export class DictionaryParameterService {

  private url: string = '/api/dictionary/parameter';

  constructor(private http: HttpClient) { }

  getAll(): Observable<DictionaryParameterEntity[]> {
    return this.http.get<DictionaryParameterEntity[]>(this.url);
  }

  add(parameter: any): Observable<any> {
    return this.http.post<any>(this.url, parameter);
  }

  update(parameter: any): Observable<any> {
    return this.http.put<any>(this.url, parameter);
  }
}
